import Screenreaders from './Screenreaders';
export default Screenreaders;
